<template>
  <nav aria-label="Page navigation">
    <ul class="pagination">
      <li class="page-item" v-if="currentPage > 1">
        <a
          @click.stop.prevent="prePage(1)"
          class="page-link"
          href="#"
          aria-label="Previous"
        >
          <span aria-hidden="true">&laquo;</span>
        </a>
      </li>

      <li
        :class="['page-item', { active: currentPage === page }]"
        v-for="page in totalPage"
        :key="page"
      >
        <a @click.stop.prevent="changePage(page)" class="page-link" href="#">{{
          page
        }}</a>
      </li>

      <li
        class="page-item"
        v-if="currentPage >= 1 && currentPage < totalPage.length"
      >
        <a
          @click.stop.prevent="nextPage(1)"
          class="page-link"
          href="#"
          aria-label="Next"
        >
          <span aria-hidden="true">&raquo;</span>
        </a>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: "ResPagination",
  props: {
    totalPage: {
      type: Array,
      required: true,
    },
    initialCurrentPage: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      currentPage: this.initialCurrentPage,
    };
  },
  watch: {
    initialCurrentPage: function () {
      this.currentPage = this.initialCurrentPage;
      console.log(this.currentPage);
    },
  },

  methods: {
    changePage(page) {
      this.currentPage = page;
      this.$emit("change-page", {
        currentPage: page,
      });
    },
    prePage(reducePage) {
      this.currentPage -= reducePage;
      this.$emit("pre-page", {
        currentPage: reducePage,
      });
    },
    nextPage(addPage) {
      this.currentPage += addPage;
      this.$emit("next-page", {
        currentPage: addPage,
      });
    },
  },
};
</script>
